import debounce from 'lodash/debounce'
import Component from '../core/Component'
import Scroll from '../services/Scroll'
import { queryAll } from '../utils/dom'

export default class ProductListBrands extends Component {
    constructor(element, options) {
        super(element,options)

        this.handleDebouncedResize = debounce(this.handleResize,300)
    }

    prepare() {
        this.fillWithPlaceholders()
        Scroll.on('resize', this.handleDebouncedResize)
    }

    destroy() {
        Scroll.off('resize', this.handleDebouncedResize)
    }

    handleResize = () => {
        this.fillWithPlaceholders()
    }

    fillWithPlaceholders() {
        const items = queryAll('.product-List-item', this.element)
        const regularItems = items.filter(item => item.dataset.placeholder === undefined)
        const placeholderItems = items.filter(item => item.dataset.placeholder !== undefined)
        const windowWidth = window.innerWidth
        let itemsPerRow = 0

        if (windowWidth >= 1680) {
            itemsPerRow = 5
        } else if (windowWidth >= 1040) {
            itemsPerRow = 4
        } else if (windowWidth >= 768) {
            itemsPerRow = 3
        } else {
            itemsPerRow = 2
        }

        let countToAdd = itemsPerRow - (regularItems.length % itemsPerRow)
        if (countToAdd == itemsPerRow) {
            countToAdd = 0
        }

        placeholderItems.forEach(item => {
            item.parentNode.removeChild(item)
        })

        for (var i = 0; i < countToAdd; i++) {
            const placeholder = document.createElement('div')
            placeholder.className = 'product-List-item'
            placeholder.setAttribute('data-placeholder', '')
            this.element.appendChild(placeholder)
        }
    }
}